// extracted by mini-css-extract-plugin
export default {"loader":"SinglePhotoDropzone_loader__de86r","rotation":"SinglePhotoDropzone_rotation__KcSIh"};